import { api } from "./api";

export const getPrestamosPorRol = async (startDate, endDate) => {
  const { data } = await api.get("/estadisticas/prestamosPorRol", {
    params: { startDate, endDate },
  });
  return data;
};

export const getPrestamosPorCarrera = async (startDate, endDate) => {
  const { data } = await api.get("/estadisticas/prestamosPorCarrera", {
    params: { startDate, endDate },
  });
  return data;
};

export const getPrestamosPorFondo = async (startDate, endDate) => {
  const { data } = await api.get("/estadisticas/prestamosPorFondo", {
    params: { startDate, endDate },
  });
  return data;
};

export const getLibroMasPrestado = async (startDate, endDate) => {
  const { data } = await api.get("/estadisticas/libroMasPrestado", {
    params: { startDate, endDate },
  });
  return data;
};

export const getNumeroPrestamosActivos = async () => {
  const { data } = await api.get("/estadisticas/numeroPrestamosActivos");
  return data;
};

export const getNumeroTotalPrestamosEntreFechas = async (startDate, endDate) => {
  const { data } = await api.get("/estadisticas/numeroTotalPrestamosEntreFechas", {
    params: { startDate, endDate },
  });
  return data;
};

export const getNumeroTotalLibrosEnInventario = async () => {
  const { data } = await api.get("/estadisticas/numeroTotalLibrosEnInventario");
  return data;
};

export const getNumeroTotalUsuariosRegistrados = async () => {
  const { data } = await api.get("/estadisticas/numeroTotalUsuariosRegistrados");
  return data;
};

export const getPrestamosPorCategoriaDewey = async (startDate, endDate) => {
  const { data } = await api.get("/estadisticas/prestamosPorCategoriaDewey", {
    params: { startDate, endDate },
  });
  return data;
};
